import {atom} from "jotai";
import {
  AssetFrontendUserApi$CurrentAuthedUser,
} from "@/custolink-transpiled_by_server/bc.identity_and_access.api_methods";

export const uiAssetFrontendAuthState = atom<AssetFrontendUserApi$CurrentAuthedUser|false>(false)


